/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)
                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()

// === Mät varning + banner-höjd så sticky-stacken hamnar rätt ===
(function () {
  function setHeights() {
    var warn = document.querySelector('.nicotine-warning-bar');
    document.documentElement.style.setProperty('--nicotine-warning-height', warn ? warn.getBoundingClientRect().height + 'px' : '0px');
    var ann = document.querySelector('.announcement-bar');
    document.documentElement.style.setProperty('--announcement-bar-height', ann ? ann.getBoundingClientRect().height + 'px' : '0px');
  }
  setHeights();
  document.addEventListener('DOMContentLoaded', setHeights);
  window.addEventListener('load', setHeights);
  window.addEventListener('resize', setHeights);
})();

/* N1CE — bind Grouptify (mpg) swatches to the theme cart form (merch size fix)
   Grouptify renders its own size swatches on merch PDPs but never writes the
   chosen variant into the theme's add-to-cart form, so it always submitted the
   first variant (S). This maps the selected swatch back to the real variant id. */
(function () {
  function sync() {
    var form = document.querySelector('.product-content form[data-variants]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    var variants;
    try { variants = JSON.parse(form.dataset.variants); } catch (e) { return; }
    var selected = [].map.call(
      document.querySelectorAll('.mpg-swatch__option.selected'),
      function (el) { return (el.getAttribute('o-value') || el.textContent || '').trim(); }
    ).filter(Boolean);
    if (!selected.length) return;
    var m = variants.find(function (v) {
      return selected.every(function (val) { return (v.options || []).indexOf(val) !== -1; });
    });
    if (m && String(idInput.value) !== String(m.id)) {
      idInput.value = m.id;
      try {
        var u = new URL(location);
        u.searchParams.set('variant', m.id);
        history.replaceState({}, '', u);
      } catch (e) {}
    }
  }
  function boot() {
    sync();
    document.addEventListener('click', function (e) {
      if (e.target.closest('.mpg-swatch__option')) setTimeout(sync, 60);
    });
    var host = document.querySelector('.mpg-swatch') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(host, {
        subtree: true, attributes: true, childList: true, attributeFilter: ['class']
      });
    }
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();